module.exports = __webpack_public_path__ + "static/media/joinedTournaments_50_75.9c054746.png";